import { useWindowWidth } from '@elotech/components';
import * as authActions from 'common/auth/Actions.js';
import AuthService from 'common/auth/AuthService.js';
import * as uiActions from 'common/ui/Actions.js';
import Header from 'components/Header.jsx';
import keycloakService from 'keycloak/KeycloakService.js';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory, withRouter } from 'react-router-dom';

const HeaderContainer = props => {
  const history = useHistory();
  const width = useWindowWidth();
  const {
    auth,
    ui,
    sidebarToggle,
    isLogged,
    integradoUnico,
    unicoParcial,
    isCloud,
    config,
    children
  } = props;

  useEffect(() => {
    if (width <= 768 && !ui.sidebarToggled) {
      sidebarToggle();
    }
    // eslint-disable-next-line
  }, [width]);

  const getHeaderTitle = () => {
    const nomeEntidade = auth.getIn(['userInfo', 'entidade', 'nome']) || '';
    return nomeEntidade === '' ? config.entidade : `${nomeEntidade}`;
  };

  const onLogin = () => {
    if (integradoUnico || unicoParcial) {
      AuthService.redirectToLogin();
    } else if (isCloud) {
      keycloakService.login(() => {
        window.location.href = '/';
      });
    } else {
      history.push('/login');
    }
  };

  return (
    <Header
      {...props}
      onLogin={onLogin}
      headerTitle={getHeaderTitle()}
      isLogged={isLogged}
      nomeModulo={config.nomeModulo}
    >
      {children}
    </Header>
  );
};

const allActions = {
  ...authActions,
  ...uiActions
};

function mapStateToProps(state) {
  return {
    auth: state.auth,
    ui: state.ui,
    config: state.config
  };
}

export default connect(
  mapStateToProps,
  allActions
)(withRouter(HeaderContainer));
